import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'antd'

class IconText extends Component {
  render() {
    const { type, text, iconProps, position } = this.props
    const Right = () => (
      <span {...this.props}>
        <Icon type={type} style={{ marginRight: 8 }} {...iconProps} />
        {text}
      </span>
    )
    const Left = () => (
      <span {...this.props}>
        {text}
        <Icon type={type} style={{ marginLeft: 8 }} {...iconProps} />
      </span>
    )
    return position === 'right' ? <Right /> : <Left />
  }
}

IconText.propTypes = {
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  position: PropTypes.string,
  iconProps: PropTypes.any,
}
IconText.defaultProps = { position: 'right' }

export default IconText
